import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { NotifyService } from "./shared";
import * as  XLSX from "xlsx";

@Injectable()
export class DataExportService {

    constructor() {
    }

    public ConvertRowsToCSVString(columns: IExportColumnDefinition[], data) {
        let LINE_SEPARATOR = '\r\n';
        let COLUMN_SEPARATOR = this.GetListSeperator();
        let resultCSV = "";

        columns.map(column => {
            resultCSV += this.EscapeRestrictedChars(column.colDef.headerName);
            resultCSV += COLUMN_SEPARATOR;
        });
        resultCSV += LINE_SEPARATOR;

        if (!data)
            return resultCSV;

        data.map(model => {
            columns.map(column => {
                let cellContent = (model[column.colId] != null) ? model[column.colId] : "";
                resultCSV += this.EscapeRestrictedChars(cellContent);
                resultCSV += COLUMN_SEPARATOR;
            });
            resultCSV += LINE_SEPARATOR;
        });

        return resultCSV;
    }


    public ExtractDataForExcelExport(columns: IExportColumnDefinition[], data): IExcelExportData {
        let columnHeaders: any = {};
        columns.map(column => {
            columnHeaders[column.colId] = this.EscapeRestrictedChars(column.colDef.headerName);
        });

        if (!data)
            return { ColumnHeaders: columnHeaders, Data: null };

       let extractedData =  data.map(model => {
            let trimedObject = {};
            columns.map(column => {
                trimedObject[column.colId] = model[column.colId]
            });
            return trimedObject;
        });

        return { ColumnHeaders: columnHeaders, Data: extractedData };
    }

    public ExportAsCsv(csvData: string, fileName: string = "export") {
        fileName = fileName + ".csv"
        this.ExportCsv(csvData, fileName)
    }

    public ExportAsExcel(excelExport: IExcelExportData, fileName: string = "export") {
        let workBook = XLSX.utils.book_new();
        workBook.Props = {
            Title: "WA",
            Subject: "WA from Nepraunik",
            Author: "Nepraunik portal",
        }
        workBook.SheetNames.push("WHA");
        let ws = XLSX.utils.json_to_sheet(excelExport.Data);
        let headers = this.GetHeaders(ws);
        headers.map(cell => {
            cell.v = excelExport.ColumnHeaders[cell.v];
        })

        workBook.Sheets["WHA"] = ws;
        XLSX.writeFile(workBook, fileName + ".xlsx")
    }

    public DownloadBlob(blob: Blob, fileName: string): any {
        if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileName);
        }
        else {
            var downloadLink = document.createElement("a");
            downloadLink.href = window.URL.createObjectURL(blob);
            downloadLink.download = fileName;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }
    }
    private GetHeaders(sheet: XLSX.WorkSheet): any {
        let colCount = XLSX.utils.decode_range(sheet["!ref"]).e.c;
        let headers = [];
        for (let i = 0; i <= colCount; i++) {
            headers.push(sheet[XLSX.utils.encode_cell({ r: 0, c: i })])
        }
        return headers;
    }

    private ExportCsv(csvData: string, fileName: string, type?: string) {
        type = type || "text/csv;charset=utf-8;";

        let blob = new Blob(["\ufeff", csvData], {
            type: type
        })

        this.DownloadBlob(blob, fileName);
    }

    private EscapeRestrictedChars(content: string) {
        return content.replace(/,/g, ' ');
    }

    private GetListSeperator(): string {
        let list = ['a', 'b'];
        return (list.toLocaleString().charAt(1))
    }
}

export interface IExportColumnDefinition {
  colDef: IColumnDfeinition;
  colId: string;
}

interface IColumnDfeinition {
    field: string;
    headerName: string;
}


export interface IExcelExportData {
  ColumnHeaders: { [key: string]: string };
    Data: any[];
}



// WEBPACK FOOTER //
// ./src/app/shared/data-export.service.ts